import {
    computed,
    Directive,
    ElementRef,
    Injector,
    input,
    numberAttribute,
    OnDestroy,
    OnInit,
    signal,
    Signal
} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {distinctUntilChanged, map} from 'rxjs/operators';
import {ResizeObserverService} from '../resize-observer';
import {ResponsiveColsService} from './responsive-cols.service';

@Directive({
    selector:   '[responsiveCol]',
    standalone: false,
    host:       {
        '[style.display]': 'displayStyleValue()'
    }
})
export class ResponsiveColDirective implements OnInit, OnDestroy {

    public readonly priority = input(1, {alias: 'responsiveCol', transform: numberAttribute});

    public readonly isHidden = signal<boolean>(false);

    public readonly width = this.createWidthSignal();

    public readonly displayStyleValue = computed(() =>
        this.isHidden()
            ? 'none'
            : undefined
    );

    constructor(
        public elementRef: ElementRef,
        private responsiveColsService: ResponsiveColsService,
        private resizeObserverService: ResizeObserverService,
        private injector: Injector
    ) {}

    public ngOnInit(): void {
        this.responsiveColsService.registerCol(this);
    }

    public ngOnDestroy(): void {
        this.responsiveColsService.unregisterCol(this);
    }

    private createWidthSignal(): Signal<number> {
        const width$ = this.resizeObserverService.observe(this.elementRef.nativeElement).pipe(
            map(e => e.contentRect.width),
            distinctUntilChanged()
        );

        return toSignal(width$, {injector: this.injector});
    }

}
